<template>
  <div class="case-customer-view">
    <grid-details-component
      v-if="customer && customer.id"
      :display_spec="customerProfileSpecs"
      :item="customer"
      :item_keys="customer_keys">
    </grid-details-component>
    <!-- Loader -->
    <loader-component v-else></loader-component>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import GridDetailsComponent from '@/components/layout/grid/GridDetailsComponent.vue'
  import { customerProfileSpecs, defaultCustomerKeys } from '@/display_context/display_context'
  import LoaderComponent from '@/components/layout/utility/LoaderComponent'

  export default {
    name: 'case-customer-view',
    components: {
      GridDetailsComponent,
      LoaderComponent
    },
    data () {
      return {
        customerProfileSpecs: customerProfileSpecs,
        customer_keys: defaultCustomerKeys
      }
    },
    props: {
      caseId: {
        required: true
      }
    },
    computed: {
      ...mapGetters([
        'getCaseForId',
        'getCustomerForId'
      ]),
      kase () {
        return this.getCaseForId(this.caseId) || {}
      },
      getCustomer () {
        return this.kase.customer || this.getCustomerForId(this.kase.customer.id)
      },
      customer () {
        return this.kase.customer ? this.getCustomer : {}
      }
    }
  }
</script>

<style lang="sass" scoped>
  .case-customer-view
    position: relative
</style>
